import React from 'react';
import PropTypes from 'prop-types';
import { Box, makeStyles, Stepper } from '@material-ui/core';
import { Step } from './Step';

const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    right: '25px',
    '.rtl &': {
      left: '25px',
      right: 'initial',
    },
  },
  stepper: {
    padding: 0,
  },
}));

export const StepperNavigation = ({ stepsNumber, activeStep }) => {
  const classes = useStyles();
  const steps = [...Array(stepsNumber).keys()];

  return (
    <Box className={classes.root}>
      <Box display="flex">
        <Stepper className={classes.stepper} activeStep={activeStep}>
          {steps.map((step) => (
            <Step
              key={step}
              value={step + 1}
              isActiveStep={activeStep === step || activeStep > step - 1}
            />
          ))}
        </Stepper>
      </Box>
    </Box>
  );
};

StepperNavigation.propTypes = {
  stepsNumber: PropTypes.number.isRequired,
  activeStep: PropTypes.number.isRequired,
};
